import React from "react"
import { keyframes } from '@emotion/react'

import Layout from "../../../layouts"
import LargeHero from "../../../components/elements/largeHero"
import { SizedText } from "../../../components/elements/typography"
import Grid from "../../../components/elements/grid"
import SwipeNSaveSection from "../../../components/sections/swipeNSaveSection"
import ReviewSection from "../../../components/sections/reviewSection"
import { StaticImage } from "gatsby-plugin-image"
import Icon from "../../../components/elements/icon"
import SEO from "../../../components/elements/seo"

import savingsIcon from "../../../theme/icons/savings.svg"
import mmaIcon from "../../../theme/icons/mma.svg"
import cdIcon from "../../../theme/icons/cds.svg"
import iraIcon from "../../../theme/icons/iras.svg"

const gradient = keyframes`
  0% {background-position: 0%}
  100% {background-position: 100%}
}
`

const AccountBox = ({name, width, icon, children }) => (
  <div css={{
    width: `100%`,
    minWidth: `260px`,
    backgroundColor: `hsla(0,0%,100%,.75)`,
    boxShadow: `0 1px 2px rgba(0,0,0,0.15)`,
    marginBottom: `2rem`,
    borderRadius: `16px`,
    padding: `2rem`,
    textAlign: `center`,
    '& p': {
      fontWeight: `600`,
      '& span': {
        fontWeight: `400`
      }
    }, 
    '@media (min-width: 736px)': { width: `49% !important`, }, 
    '@media (min-width: 1495px)': { width: `24% !important`,} 
  }}>
    <div css={{
      fontSize: `4.624rem`,
    }}>
      <Icon icon={icon} overrides={{verticalAlign: `-0.1rem !important`}}/> 
    </div>
    <SizedText as="h2" smallSize="2.281" largeSize="1.802">{name}</SizedText>
    <div css={{textAlign: `left`}}>{children}</div>
  </div>
)

const PersonalSavingsIndexPage = () => {
  return (
    <Layout isSubMenuOpen={true} openAccountLink={true}>

      <SEO
        title="TCB Personal Savings and Investment Accounts"
        description="Get your rainy day fund started today.  TCB makes saving simple with a number of savings and investment options, including TCB Swipe-N-Save automatic round-up savings program.  Find the perfect account for you today."
        location="/personal/savings"
        ogImg='/images/social-graph/the-claxton-bank.jpg'
      />

      <LargeHero.Container
        background={{ 
          //https://www.svgbackgrounds.com/
          background: `url('data:image/png;base64,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')`,
          backgroundRepeat: `repeat`,
          boxShadow: `inset 0px 11px 8px -10px rgba(0,0,0,0.4), inset 0px -11px 8px -10px rgba(0,0,0,0.4)`,
          borderBottom: `1px solid #3e769d`,
          padding: `2rem 0 0 0`,
        }}
        breadcrumbLinks={[
          { path: "/", text: "Home" },
          { path: "/personal/", text: "Personal Banking" },
          { path: "/personal/savings/", text: "Savings Accounts" }
        ]}
        styles={{
          paddingBottom: `0`,
          '@media (min-width: 680px)': {
            //paddingBottom: `4rem`,
            '.heroContent': { width: `calc(60% - 1rem)`},
            '.heroImage': { width: `calc(40% - 1rem)`},
          },

      }}>
        <LargeHero.Content>
          <LargeHero.Eyebrow text="Personal Savings" />
          <h1 css={{fontFamily: `Proxima-nova`, textTransform: `uppercase`, 'span': {display: `block`, lineHeight: `1.25`, padding: `0.25rem 0 0 0`, hyphens: `auto`}}}>
            <SizedText as="span" smallSize="2.281" largeSize="4.624">Get your rainy day fund started now.</SizedText>
          </h1>
          <p css={{fontSize: `1.125rem`, maxWidth: `850px`, padding: `0 0 1.25rem 0`, lineHeight: `1.75`, textAlign:`justify`, hyphens: `auto` }}>
            Looking to save more money, but don't know where to start? Then earn interest with a TCB Savings Account. Save when you need it most, when your schedule allows. We make saving money easy, flexible and rewarding.  
          </p>         
        </LargeHero.Content>
        <LargeHero.Image styles={{ alignSelf: `end`}}>
          <StaticImage 
            css={{
              display: `block !important`,  
              '@media (min-width: 665px)': { display: 'none !important' },  
              '@media (min-width: 1400px)': { display: 'block !important' }, 
            }} 
            src="../../../images/people/personal-savings_wide.png" alt="" />
          <StaticImage 
            css={{
              display: `none !important`,  
              '@media (min-width: 665px)': { display: 'block !important' }, 
              '@media (min-width: 1400px)': { display: 'none !important' },  
            }} 
            src="../../../images/people/personal-savings_tall.png" alt="" />
        </LargeHero.Image>
      </LargeHero.Container>

      <Grid.SafeWidthSection>
        <Grid.Block start="2" span="10" styles={{margin: `4rem 0`}}>
          <div css={{display: `flex`, justifyContent: `space-between`, flexWrap: `wrap`}}>
            <AccountBox name="Regular Savings" icon={savingsIcon}>
              <p>
                Earns Interest<br />
                <span>Variable interest rate, compounded quarterly and credited quarterly</span>
              </p>
              <p>
                $0 or $10.00 Quarterly Maintenance Fee <br />
                <span>No monthly maintenance fee if you maintain a balance daily balance of $100.</span>
              </p>
              <p>
                $100 Minimum to Open <br />
                <span>There is a minimum deposit of $100 required to open this account online.</span>
              </p>
              <p>Unlimited Deposits</p>
              <p>
                Limited Withdrawals<br />
                <span>A chargeable debit fee of $5.00 will be charged for each debit transaction over 3 per quarter.</span>
              </p>
            </AccountBox>
            <AccountBox name="Money Market" icon={mmaIcon}>
              <p>Earns Interest<br />
                <span>Variable interest rate, compounded monthly and credited monthly.</span>
              </p>
              <p>
                $0 or $5.00 Monthly Maintenance Fee<br />
                <span>No monthly maintenance fee if you maintain a daily balance of $1,000.</span>
              </p>
              <p>
                $1000 Minimum to Open<br/>
                <span>There is a minimum deposit of $1000 required to open this account online.</span>
              </p>
              <p>Unlimited Deposits</p>
              <p>
              Limited Withdrawls<br/>
                <span>A chargeable debit fee of $5.00 will be charged for each debit transaction over 6 per statement cycle.</span>
              </p>
            </AccountBox>
            <AccountBox name="CDs" icon={cdIcon}>
              <p>
                Earns Interest<br />
                <span>Fixed interest rate, compounds and credits periodically depending on CD duration.</span>
              </p>
              <p>
                Multiple Durations Available<br />
                <span css={{display: `inline-block`, marginLeft: `1rem`}}>
                •	91 days minimum deposit $2500<br />
                •	182 days minimum deposit $2500<br />
                •	12 months minimum deposit $500<br />
                •	18 months minimum deposit $500<br />
                •	24 months minimum deposit $500<br />
                •	36 months minimum deposit $500<br />
                •	48 months minimum deposit $500<br />
                •	60 months minimum deposit $500<br />
                </span>
              </p>
              <p>
                Early Withdrawal Penalty <br />
                <span>There may be a 3 to 6 month early withdrawal penalty.</span>
              </p>
            </AccountBox>
            <AccountBox name="IRAs" icon={iraIcon}>
              <p>
                Earns Interest<br />
                <span>Fixed interest rate, compounded monthly and credited monthly.</span>
              </p>
              <p>
                Multiple Durations Available<br />
                <span css={{display: `inline-block`, marginLeft: `1rem`}}>
                •	12 months minimum deposit $500<br />
                •	24 months minimum deposit $500<br />
                •	60 months minimum deposit $500<br />
                </span>
              </p>
              <p>
                Tax Advantages<br />
                <span>
                Contributions may be tax deductible or qualified distributions may be tax free depending on account type.
                </span>
              </p>
              <p>
                Required Minimum Distribution<br />
                <span>
                  The IRS may require that you withdraw a minimum amount annually for some types of accounts.
                </span>
              </p>
            </AccountBox>

          </div>
        </Grid.Block>
      </Grid.SafeWidthSection>

      <SwipeNSaveSection />
      <ReviewSection />


    </Layout>

    
  )
}

export default PersonalSavingsIndexPage